module.exports = __webpack_public_path__ + "img/Wp_2008.382d2d39.png";